import { ChakraProvider } from "@chakra-ui/react";
import { Navbar } from "./components/navbar";
import { Body } from "./components/body";

const Main = () => {
  return <>
      <div>
          <Navbar/>
          <Body />
      </div>
      </>
}

export function App() {
  return (
    <ChakraProvider>
      <Main />
    </ChakraProvider>
  )
}

